module.exports = __webpack_public_path__ + "img/step47_down.a44bd849.png";